<!-- 回单管理  回单寄出 -->
<template>
  <div>
    <div id="login-load-mask" @click.stop></div>
    <div id="login-sq-outer" @click.stop>
        <div class="login-sq-mask"></div>
        <div class="login-sq-box">
            <div class="login-sq-title">登录授权申请</div>
            <div class="login-sq-form">
                <div class="login-sq-item login-sq-item-nohide">
                    <label>账户:</label>
                    <input type="text" autocomplete="off" id="sq-loginname" disabled />
                    <div class="login-sq-tipss red"></div>
                </div>
                <div class="login-sq-item">
                    <label><span class="red">*</span>姓名:</label>
                    <input type="text" autocomplete="off" id="sq-username" />
                    <div class="login-sq-tipss red">请输入姓名</div>
                </div>
                <div class="login-sq-item">
                    <label><span class="red">*</span>电话:</label>
                    <input type="text" autocomplete="off" id="sq-mobile" />
                    <div class="login-sq-tipss red">请输入电话</div>
                </div>
                <div class="login-sq-item">
                    <label><span class="red">*</span>说明:</label>
                    <textarea autocomplete="off" id="sq-remark"></textarea>
                    <div class="login-sq-tipss red">请输入说明</div>
                </div>
                <div class="login-sq-item login-sq-item-nohide">
                    <label>状态:</label>
                    <span class="login-sq-status" id="login-sq-status" state="0">未申请</span>
                    <span class="login-sq-refresh"><i class="l-icon l-icon-refresh"></i>刷新状态</span>
                </div>
                <div class="red login-sq-tips">请联系管理员进行审核</div>
                <div class="login-sq-btn" id="login-sq-btn">申请</div>
            </div>
            <div id="login-sq-installinfo"></div>
            <div class="login-sq-btn" id="login-sq-outbtn">退出登录</div>
        </div>
    </div>
  </div>
</template>

<script>
import { includeLinkList, includeScriptList } from '@/utils/common'
import { CSS_BASEURL, RESOURCE_BASE_URL, SCRIPT_BASEURL } from '@/utils/enum'

export default {
  name: 'BindingEquipment', // 绑定设备登录页
  mounted () {
    includeScriptList([
      SCRIPT_BASEURL + '/shared/BindingEquipment.js'
    ])
  }
}
</script>

<style >
    #login-sq-outer,
    #login-load-mask {
        position: fixed;
        left: 0;
        top:0;
        z-index: 99999999;
        width: 100%;
        height:100%;
        overflow: hidden;
        display:none;
    }
    .login-sq-mask,
    #login-load-mask {
        width: 100%;
        height: 100%;
        background:rgba(0,0,0,0.5);
    }
    .login-sq-box{
        position: absolute;
        left: 50%;
        top:50%;
        background:#fff;
        width: 400px;
        -webkit-transform: translate(-50%,-50%);
           -moz-transform: translate(-50%,-50%);
            -ms-transform: translate(-50%,-50%);
             -o-transform: translate(-50%,-50%);
                transform: translate(-50%,-50%);
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.5);
        border-radius: 5px;
        overflow: hidden;

    }
    .login-sq-title{
        line-height: 40px;
        font-size: 18px;
        text-align: center;
        background: #03A9F4;
        color:#fff;
    }
    .login-sq-form{
        padding: 10px;
        padding-top: 25px;
        padding-bottom: 0;
    }
    .login-sq-item{
        /*margin-bottom: 10px;*/
        overflow: hidden;
    }
    .login-sq-form label{
        width: 15%;
        padding-right: 10px;
        text-align: right;
        float: left;
        line-height: 30px;
        box-sizing: border-box;
    }
    .login-sq-form input,.login-sq-form textarea{
        width: 80%;
        border:1px solid #ddd;
        float: left;
        height: 30px;
        text-indent: 5px;
        box-sizing: border-box;
    }
    .login-sq-form .errColor{
        border-color: red;
    }
    .login-sq-form textarea{
        text-indent: 0px;
        height: 80px;
        resize: unset;
    }
    .login-sq-status{
        float: left;
        line-height: 30px;
        color:red;
        font-weight: bolder;
        font-size: 16px;
    }
    .login-sq-btn {
        height: 30px;
        line-height: 30px;
        background: #03A9F4;
        color: #fff;
        text-align: center;
        font-size: 18px;
        letter-spacing: 5px;
        text-indent: 5px;
        border-radius: 2px;
        cursor: pointer;
        margin-top: 10px;
        box-shadow: 1px 1px 6px 0px rgba(0,0,0,0.5);
    }
    .login-sq-btn:hover{
        opacity: 0.8;
    }
    .login-sq-tips{
        display:none;
        text-align: center;
        font-size: 16px;
        padding: 10px 0;
    }
    .login-sq-tipss{
        float: left;
        width: 85%;
        padding-left: 15%;
        height: 25px;
        line-height: 25px;
        visibility:hidden;
    }
    .login-sq-tipss.showTipss{
        visibility:visible;
    }
    .login-sq-refresh{
        float: left;
        line-height: 30px;
        cursor: pointer;
        margin-left: 30px;
        display:none;
    }
    .login-sq-refresh .l-icon-refresh{
        background:none;
        margin-right: 5px;
    }
    .login-sq-refresh:hover{
        color:blue;
        text-decoration: underline;
    }
    #login-sq-installinfo{
        display:none;
    }
    #login-sq-outbtn{
        background: #FF9800;
        width: 95%;
        margin: 10px auto;
    }
</style>
